<template>  
    <div id="profile" class="card card-body mt-4">
      <div class="row justify-content-center align-items-center">
        <div class="col-sm-auto col-4">
          <div class="avatar avatar-xl">
            <img :src="isLoading ? loadingImageUrl : associationLogoImageSrc" :alt="$t('association.Logo_image')" class="shadow-sm" />
          </div>
        </div>
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ state.name }}</h5>            
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">          
        </div>
      </div>
    </div>
    <div id="association-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Association_info') }}</h5>
        <p class="mb-0 text-sm">{{ $t('association.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Name') }} *</label>
                <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('association.Name')">
                <span v-if="vrulesAssociationDetails$.name.$error" class="text-sm text-danger">
                  {{ vrulesAssociationDetails$.name.$errors[0].$message }}
                </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Abbreviation') }} *</label>
                <input v-model="state.abbreviation" type="text" class="form-control form-control-default" :placeholder="$t('association.Abbreviation')">
                <span v-if="vrulesAssociationDetails$.abbreviation.$error" class="text-sm text-danger">
                  {{ vrulesAssociationDetails$.abbreviation.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Chamber_of_commerce_no') }}</label>
                <input v-model="state.chamberOfCommerceNo" type="text" class="form-control form-control-default" :placeholder="$t('association.Chamber_of_commerce_no')">                
              </div>
            </div>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('association.RVORelationnumber') }}</label>
                <input v-model="state.rvoRelationnumber" type="text" class="form-control form-control-default" :placeholder="$t('association.RVORelationnumber')">                
              </div>
            </div>
            <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('association.Phone_number') }} / {{ $t('association.Mobile_number') }}</label>
                  <input v-model="state.phoneNumber" type="text" class="form-control form-control-default" :placeholder="$t('association.Phone_number')">
              </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 mt-6">          
            <button v-on:click="updateAssociationInfo" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>                                                    
        </div>
      </div>
    </div>
    <div id="address" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Address') }}</h5>
        <p class="mb-0 text-sm">{{ $t('association.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Address') }} *</label>
              <input v-model="state.address" type="text" class="form-control form-control-default" :placeholder="$t('association.Address')">
              <span v-if="vAddress$.address.$error" class="text-sm text-danger">
                {{ vAddress$.address.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.House_number') }} *</label>
              <input v-model="state.houseNumber" type="text" class="form-control form-control-default" :placeholder="$t('association.House_number')">
              <span v-if="vAddress$.houseNumber.$error" class="text-sm text-danger">
                {{ vAddress$.houseNumber.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>      
        <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.City') }} *</label>
              <input v-model="state.city" type="text" class="form-control form-control-default" :placeholder="$t('association.City')">
              <span v-if="vAddress$.city.$error" class="text-sm text-danger">
                {{ vAddress$.city.$errors[0].$message }}
              </span>
            </div>
          </div>      
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Zipcode') }} *</label>
              <input v-model="state.zipcode" type="text" class="form-control form-control-default" :placeholder="$t('association.Zipcode')">
              <span v-if="vAddress$.zipcode.$error" class="text-sm text-danger">
                {{ vAddress$.zipcode.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Country') }} *</label>
              <input v-model="state.country" type="text" class="form-control form-control-default" :placeholder="$t('association.Country')">
              <span v-if="vAddress$.country.$error" class="text-sm text-danger">
                {{ vAddress$.country.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-6">                                
          <button v-on:click="updateAddress" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('association.Update_address') }}</button>                                                    
        </div>        
      </div>
    </div>
    <div id="webemail" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Web_and_email_info') }}</h5>
        <p class="mb-0 text-sm">{{ $t('association.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Email') }}</label>
              <input v-model="state.email" type="text" class="form-control form-control-default" :placeholder="$t('association.Email')">
              <span v-if="vrulesWebEmail$.email.$error" class="text-sm text-danger">
                {{ vrulesWebEmail$.email.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.WebsiteURL') }}</label>
              <input v-model="state.websiteURL" type="text" class="form-control form-control-default" :placeholder="$t('association.WebsiteURL')">
            </div>
          </div>
        </div>              
        <div class="col-12 col-sm-12 mt-6">                                
          <button v-on:click="updateWebEmail" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('association.Update_web_and_email') }}</button>                                                    
        </div>        
      </div>
    </div>
    <div class="row mt-4">      
      <div class="col-md-6">
        <div id="logoimage" class="card mt-4" data-animation="FadeIn">      
          <div class="row align-items-center justify-content-between">
            <div class="col">
              <div class="card-header pb-3">
                <h5>{{ $t('association.Logo_image') }}</h5>
                <p class="mb-0 text-sm">
                  {{ $t('association.Optional_information') }} ({{ $t('association.Upload_logo_image') }})
                </p>
              </div>
            </div>
            <div class="col-auto" style="margin-right: 25px;  margin-top: 10px;">
              <div class="avatar avatar-xl">
                <img
                  :src="isLoading ? loadingImageUrl : associationLogoImageSrc"
                  :alt="$t('association.Logo_image')"
                  class="shadow-sm"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row mt-2">
              <div class="col-12">
                <div id="logoImg" class="form-control border dropzone"></div>
              </div>   
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <button v-on:click="updateLogoImage" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('association.Upload_logo_image') }}</button>      
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('association.Delete_association') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteAssociation" name="Delete Association" @click="confirmDelete"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.name }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteAssociation" @click="deleteAssociation" name="button">{{ $t('association.Delete_association') }}</button>
      </div>
    </div>
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";  
  import Dropzone from "dropzone";
  import axios from 'axios';
  import { useVuelidate}  from '@vuelidate/core'
  import { email, required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'  
  import loadingImageUrl from "@/assets/img/LoadingImage.gif";
  import { useI18n } from 'vue-i18n';
  
  export default {
    name: "AssociationDetailItem",
    setup() {
      const { t } = useI18n()

        const state = reactive ({            
            association: [],                        
            id: '',
            name: '',
            abbreviation: '',
            chamberOfCommerceNo: '',
            phoneNumber: '',
            mobileNumber: '',
            address: '',
            houseNumber: '',
            city: '',
            zipcode: '',
            country: 'Nederland',
            rvoRelationnumber: '',
            email: '',
            websiteURL: '',
            logoImage: null,
            deleteAssociation: false
        })

        const rulesAssociationDetails = computed(() => ({
          name: { required: helpers.withMessage(t('common.Required'), required) },
          abbreviation: { required: helpers.withMessage(t('common.Required'), required) }
        }))

        const rulesAddress = computed(() => ({
          houseNumber: { required: helpers.withMessage(t('common.Required'), required) },
          address: { required: helpers.withMessage(t('common.Required'), required) },
          city: { required: helpers.withMessage(t('common.Required'), required) },
          zipcode: { required: helpers.withMessage(t('common.Required'), required) },
          country: { required: helpers.withMessage(t('common.Required'), required) }
        }))

        const rulesWebEmail = computed(() => ({
          email: {
            validFormat: helpers.withMessage(
              t('common.Invalid_email_address'),
              value => !value || email.$validator(value)
            )
          }
        }))
        
        const vrulesAssociationDetails$ = useVuelidate(rulesAssociationDetails, state)
        const vAddress$ = useVuelidate(rulesAddress, state)
        const vrulesWebEmail$ = useVuelidate(rulesWebEmail, state)
        
        return {
            state,
            vAddress$,
            vrulesWebEmail$,
            vrulesAssociationDetails$
        }
    },    
    components: {      
      MaterialSwitch
    },
    data() {
      return {        
        dropzoneInstance: null, 
        fileAdded: false,
        selectedFile: null, 
        associationLogoImageSrc: null,          
        isLoading: true,
        loadingImageUrl          
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;    
      this.initializeDropzoneLogo();      
      await this.fetchAssociationData(this.$route.params.id);
      await this.fetchAssociationImage();
    },
    methods: {      
      initializeDropzoneLogo() {
        const vm = this; // Store reference to the Vue component instance

        this.dropzoneLogoInstance  = new Dropzone("#logoImg", {
          url: "/file-upload", // Not used, but Dropzone requires it
          autoProcessQueue: false,
          maxFiles: 1,
          acceptedFiles: 'image/*',
        });

        this.dropzoneLogoInstance.on("addedfile", function(file) {
          vm.fileAdded = true;
          vm.selectedFile = file;
          console.log("File added:", file);
        });
      },      
      async fetchAssociationData(id) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Association/${id}`);            
            this.gets = response.data;

            if (this.gets.success) {
                this.state.association = this.gets.data;                

                this.state.id = this.state.association.id;
                this.state.name = this.state.association.name;
                this.state.abbreviation = this.state.association.abbreviation;
                this.state.chamberOfCommerceNo = this.state.association.chamberOfCommerceNo;
                this.state.phoneNumber = this.state.association.phoneNumber;                
                this.state.address = this.state.association.address;
                this.state.houseNumber = this.state.association.houseNumber;
                this.state.city = this.state.association.city;
                this.state.zipcode = this.state.association.zipcode;
                this.state.country = this.state.association.country;
                this.state.rvoRelationnumber = this.state.association.rvoRelationnumber;
                this.state.email = this.state.association.email;
                this.state.websiteURL = this.state.association.websiteURL;
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${e.message}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },
      async fetchAssociationImage() {

        try {
          this.isLoading = true;

          try {
            const responseLogo = await axios.get(`association/getassociationlogo/`, {
              params: { associationId: this.state.id },
              responseType: 'blob',
            });

            const contentTypeLogo = responseLogo.headers['content-type'];

            if (!contentTypeLogo.startsWith('image/')) {
              this.associationLogoImageSrc = require('@/assets/no-image.png');
              return;
            }

            const imageLogoBlob = responseLogo.data;
            this.associationLogoImageSrc = URL.createObjectURL(imageLogoBlob);

          } catch (error) {
            this.associationLogoImageSrc = require('@/assets/no-image.png');
            console.error('Failed to fetch logo image:', error);
          }
        } finally {
            this.isLoading = false; // Set loading state to false after fetching
        }
      },
      async updateLogoImage() {
        const files = this.dropzoneLogoInstance.getQueuedFiles();

        if (files.length > 0) {
          const file = files[0]; // Since maxFiles is set to 1, we take the first file
          const formData = new FormData();
          formData.append('image', file);
          formData.append('associationId', this.state.id);

          try {
            const response = await axios.put('association/updatelogo', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
            console.log('Image uploaded successfully:', response.data);
            this.dropzoneLogoInstance.removeAllFiles(); // Clear Dropzone after successful upload
            this.fileAdded = false; // Reset the file added flag

            this.$showSuccess('errors.Success_image_updated_successfully');
            
            this.$router.push(`/association/edit/${this.state.id}`).then(() => {
              this.fetchAssociationImage();
            });
          } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
        } else {
          this.$showError('errors.No_image_selected_for_upload');
        }
      },                       
      async updateAssociationInfo() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vrulesAssociationDetails$.$validate();                
            //console.log(this.vrulesAssociationDetails$.$error);
            
            if(!this.vrulesAssociationDetails$.$error) {     
                const response = await axios.put('Association/updateassociationinfo', {
                  "id": this.state.id,
                  "name": this.state.name,
                  "abbreviation": this.state.abbreviation,
                  "phoneNumber": this.state.phoneNumber,
                  "chamberOfCommerceNo": this.state.chamberOfCommerceNo,
                  "rvoRelationnumber": this.state.rvoRelationnumber
                });
                this.gets = response.data;

                if (this.gets.success) {

                  this.$showSuccess('errors.Success_association_details_updated_successfully');
                  
                  this.$router.push({ path: `/association/edit/${this.state.id}` }).then(() => {
                    this.fetchAssociationData(this.state.id); // Trigger data refresh or any required action
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${e.message}`);
        }                        
        this.$store.commit('setShowLoading', false);
      },
      async updateAddress() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vAddress$.$validate();                
            console.log(this.vAddress$.$error);
            
            if(!this.vAddress$.$error) {     
                const response = await axios.put('Association/updateaddress', {
                  "id": this.state.id,
                  "address": this.state.address,
                  "houseNumber": this.state.houseNumber,
                  "city": this.state.city,
                  "zipcode": this.state.zipcode,
                  "country": this.state.country
                });
                this.gets = response.data;

                if (this.gets.success) {
                  this.$showSuccess('errors.Success_association_address_updated_successfully');
                  
                  this.$router.push({ path: `/association/edit/${this.state.id}` }).then(() => {
                    this.fetchAssociationData(this.state.id); // Trigger data refresh or any required action
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${e.message}`);
        }                        
        this.$store.commit('setShowLoading', false);
      },
      async updateWebEmail() {   
        try {
            this.$store.commit('setShowLoading', true);

            const isValid = await this.vrulesWebEmail$.$validate();            
            console.log(isValid);
            
            if(isValid) {     
                const response = await axios.put('Association/updatewebemail', {
                  "id": this.state.id,
                  "email": this.state.email,
                  "websiteURL": this.state.websiteURL                  
                });
                this.gets = response.data;

                if (this.gets.success) {
                  this.$showSuccess('errors.Success_association_web_email_updated_successfully');
                  
                  this.$router.push({ path: `/association/edit/${this.state.id}` }).then(() => {
                    this.fetchAssociationData(this.state.id); // Trigger data refresh or any required action
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${e.message}`);
        }                        
        this.$store.commit('setShowLoading', false);
      },
      confirmDelete() {
        this.state.deleteAssociation = !this.state.deleteAssociation;
      },      
      deleteAssociation() {
        if (this.state.deleteAssociation) {
          this.deleteAssociation1(this.state.id)
        }
      },         
      async deleteAssociation1(id) {   
        try {            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("association/" + id);
            this.gets = response.data;

            if (this.gets.success) {

              this.$showSuccess('errors.Success_association_deleted_successfully');
              
              this.$router.push('/association');              
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${e.message}`);
        }         
      }
    }
  };
  </script>  
<style scoped>
  .avatar img {
    width: 80%;
  }
</style>